import styled, { css } from 'styled-components';
import { Table as GlobalTable } from 'styles/global';
import { device } from 'styles/device';
import { Form } from '@unform/web';
import { transparentize, lighten, darken } from 'polished';
import PerfectScrollbar from 'react-perfect-scrollbar';

interface TdFlagProps {
  $isRede?: boolean;
}
interface VeiculacaoProps {
  $alterada?: boolean;
}
interface IFilterItemProps {
  name: string;
}

interface ScrollProps {
  height?: string;
}

export const VeiculacaoForm = styled(Form)`
  > div {
    section {
      margin-bottom: 15px;
      padding-bottom: 5px;
      border-bottom: 1px solid
        ${props => transparentize(0.5, props.theme.fontColor)};
    }
    // Para juntar (orientar horizontalmente) as duas datas (data início e data fim)
    &:first-of-type {
      display: flex;
      > div:first-of-type {
        //Para distanciar uma data da outra
        margin-right: 5px;
      }
    }
  }
`;

export const ExibicaoModal = styled.div`
  > div {
    align-items: baseline;
    justify-content: center;
    margin-bottom: 20px;
    div {
      display: flex;
      justify-content: space-between;
      margin-bottom: 10px;
      align-items: center;
      gap: 10px;
      padding: 0 10px;
      &:hover {
        transition: all 0.25s ease;
        ${props =>
          props.theme.name === 'dark'
            ? css`
                background-color: ${props =>
                  lighten(0.03, props.theme.cardBackgroud)};
              `
            : css`
                background-color: ${props =>
                  darken(0.03, props.theme.cardBackgroud)};
              `}
      }
    }
  }
  form {
    display: flex;
    gap: 10px;
    align-items: baseline;
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  .scrollbar-container {
    /* Código para telas menores */
    @media ${device.desktop} {
      height: calc(100vh - 300px);
    }
    /* Código para telas maiores */
    @media not ${device.desktop} {
      height: calc(100vh - 270px);
    }
    padding: 0 1rem;
  }
  > nav {
    display: flex;
    align-items: center;
    width: 100%;
    justify-content: space-between;
    padding-bottom: 10px;
    > button {
      width: 15rem;
      caret-color: transparent;
      svg {
        margin-right: 10px;
      }
    }
    > div {
      width: 15rem;
    }
  }
`;

export const Scroll = styled(PerfectScrollbar)<ScrollProps>`
  max-height: ${props => (props.height ? props.height : 'auto')};
  padding: 0px !important;
`;

export const Table = styled(GlobalTable)`
  th {
    &:nth-of-type(1) {
      width: 20px;
    }
    &:nth-of-type(2) {
      width: 80px;
    }
    &:nth-of-type(3) {
      width: 80px;
      text-align: center;
    }
    &:nth-of-type(5) {
      width: 132px;
      > div {
        display: flex;
        align-items: baseline;
        justify-content: center;
      }
    }
    &:nth-of-type(6),
    &:nth-of-type(7),
    &:nth-of-type(8) {
      width: 170px;
      text-align: center;
    }
    &:nth-of-type(9) {
      width: 170px;
      text-align: left;
    }
    &:nth-of-type(10) {
      width: 120px;
      text-align: center;
    }
    &:nth-of-type(11) {
      width: 50px;
      justify-items: center;
      text-align: center;
    }
    &:nth-of-type(12) {
      width: 50px;
      justify-items: center;
      text-align: center;
    }
    &:nth-of-type(13) {
      width: 50px;
      justify-items: center;
      text-align: center;
    }
  }
  tbody {
    tr {
      height: 61px;
      td {
        // CM
        &:nth-of-type(3) {
          text-align: center;
        }
        // EXIB
        &:nth-of-type(5) {
          align-items: center;
          display: flex;
          justify-content: center;
        }
        //Flags
        &:nth-of-type(6),
        &:nth-of-type(7),
        &:nth-of-type(8) {
          > div {
            margin: 0 auto;
          }
        }
        // Avatar
        &:nth-of-type(10) {
          justify-items: center;
          text-align: center;
        }
        // Buttons
        &:nth-of-type(11) {
          width: 50px;
          justify-items: center;
          text-align: center;
        }
        &:nth-of-type(12) {
          width: 50px;
          justify-items: center;
          text-align: center;
        }
        &:nth-of-type(13) {
          width: 50px;
          justify-items: center;
          text-align: center;
        }
      }
    }
  }
`;

export const ExibicaoTable = styled(GlobalTable)`
  th {
    &:nth-of-type(1) {
      width: 80px;
    }
    &:nth-of-type(3) {
      width: 300px;
      /* text-align: center; */
    }
    &:nth-of-type(4) {
      text-align: center;
      width: 200px;
    }
  }
`;

export const Veiculacao = styled.div<VeiculacaoProps>`
  display: flex;
  align-items: center;
  color: ${props => (props.$alterada ? 'yellow' : props.theme.fontColor)};
  gap: 5px;
`;
export const TdFlag = styled.td<TdFlagProps>`
  font-size: 1.0625rem;
  color: ${props => props.theme.fontColor};
  div {
    margin-right: 5px;
    width: 10px;
    height: 40px;

    ${props =>
      props.$isRede
        ? css`
            background: ${props.theme.button.warn.in};
          `
        : css`
            pointer-events: none;
          `}
  }
`;

export const FilterItem = styled.fieldset<IFilterItemProps>`
  padding: 10px 0 5px 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 5px;
  border: 1px solid ${props => props.theme.loadingTableColor};
  margin-right: 5px;
  &:first-of-type {
    margin-left: 20px;
  }
  &:last-of-type {
    margin-right: 0px;
  }

  legend {
    font-size: 0.8rem;
    padding: 0px 5px;
    color: ${props => props.theme.fontColor};
    opacity: 0.7;
  }

  div {
    align-items: center;
    justify-content: center;
    /* Código para telas menores */
    @media (max-width: 1840px) {
      grid-template-columns: ${props =>
        props.name === 'status' ? '1fr' : 'repeat(5, 1fr)'};
    }
    /* Código para telas maiores */
    @media not (max-width: 1840px) {
      grid-template-columns: ${props =>
        props.name === 'status' ? '1fr 1fr' : 'repeat(10, 1fr)'};
    }
  }
`;

export const Filter = styled.div`
  display: flex;
  justify-content: center;
  padding-right: 1rem;
`;
